import dynamic from 'next/dynamic';

import { Int32StringHotelListFeaturesViewModel } from '@api/v3';
import { useDevice } from '@contexts/device';

const DesktopFeatures = dynamic(() => import('./DesktopFeatures'));
const MobileFeatures = dynamic(() => import('./MobileFeatures'));

const Features = ({
  hightlights,
}: {
  hightlights: Int32StringHotelListFeaturesViewModel[];
}) => {
  const { isDesktop } = useDevice();
  return isDesktop ? (
    <DesktopFeatures hightlights={hightlights} />
  ) : (
    <MobileFeatures hightlights={hightlights} />
  );
};

export default Features;
